import { useState } from 'react'
import classNames from 'classnames'

import { EMPTY_STRING } from '../../../constants/common'
import { useDebounce, useInfiniteItemsListLoader } from '../../../hooks'
import { List as ListComponent } from '../../List'
import { EmptyListItem } from '../../ListItem'
import { MultiValuedListMoreFilter } from '../../MultiValuedList'

import {
  SEARCH_DEBOUNCE_TIMEOUT,
  THRESHOLD_END_INDEX,
} from './EntityAsyncMultiValuedInfiniteListMoreItems.constants'

import * as styles from './EntityAsyncMultiValuedInfiniteListMoreItems.module.css'

function EntityAsyncMultiValuedInfiniteListMoreItems({
  Item,
  List = ListComponent,
  apiParams,
  className = styles.EntityAsyncMultiValuedInfiniteListMoreItems,
  getApiParamsInit,
  getApiParamsLoadNext,
  getApiParamsUpdate,
  getData,
  getDataItems,
  itemProps,
  searchDebounceTimeout = SEARCH_DEBOUNCE_TIMEOUT,
  searchPlaceholder,
  thresholdEndIndex = THRESHOLD_END_INDEX,
  withPagination = true,
  withSearch = true,
  ...restProps
}) {
  const [searchValue, setSearchValue] = useState(EMPTY_STRING)

  const debouncedSearch = useDebounce(searchValue, searchDebounceTimeout)

  const preparedApiParams = {
    ...apiParams,
    search: debouncedSearch,
  }

  const { getThresholdItemProps, items, loadingInitial, loadingMore } =
    useInfiniteItemsListLoader({
      apiParams: preparedApiParams,
      getApiParamsInit,
      getApiParamsLoadNext,
      getApiParamsUpdate,
      getData,
      getDataItems,
      thresholdEndIndex,
      withPagination,
    })

  return (
    <List
      {...restProps}
      className={classNames(className, { [styles.withSearch]: withSearch })}
      isLoading={loadingInitial || loadingMore}
      searchElement={
        withSearch ? (
          <MultiValuedListMoreFilter
            disabled={loadingInitial}
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={setSearchValue}
          />
        ) : null
      }
    >
      {items?.length === 0 && !(loadingInitial || loadingMore) ? (
        <EmptyListItem />
      ) : null}
      {items?.map((item, index) => (
        <Item
          {...itemProps}
          {...item}
          {...getThresholdItemProps(index)}
          key={index}
        />
      ))}
    </List>
  )
}

export default EntityAsyncMultiValuedInfiniteListMoreItems
